"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _reactHotLoader = require("react-hot-loader");

var _reactRedux = require("react-redux");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reduxModal = require("redux-modal");

var _actionCreators = require("../../../redux/modules/monitoring/actionCreators");

var _browserHistory = require("../../../browserHistory");

var _selections = require("../../../redux/modules/_BETA/selections");

var _Equip = _interopRequireDefault(require("../../../components/Equip"));

var _Loading = _interopRequireDefault(require("../../../components/Loading"));

var _Page = require("../../../components/Layout/Page");

var _storage = require("../../../utils/storage");

var _columns = require("../../../utils/columns");

var routes = _interopRequireWildcard(require("../../../utils/routes"));

const DEFAULT_SORT = {
  option: _columns.equipColumns.TRIGGERED_RULES.key,
  direction: _columns.equipColumns.TRIGGERED_RULES.sortDirection
};
const PERSIST_KEY = 'equipGrid';
const PERSIST_PROP = 'Equip-colSort';

const mapStateToProps = state => {
  return {
    appSetupComplete: state.appSetup.appSetupComplete,
    siteGroups: state.monitoring.siteGroups,
    userSites: state.userSites,
    userDisplayName: state.auth.user.display_name,
    loading: state.monitoring.loading,
    ready: state.monitoring.ready,
    shouldRequest: state.requestSchedule.shouldRequestMonitoring,
    error: state.insights.error,
    selectedSites: state.betaSelections.selectedSites,
    activeSite: state.betaSelections.activeSite,
    showSnoozed: state.insights.showSnoozed,
    urlHistory: state.urlHistory,
    timeRange: state.betaSelections.daysRange
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestInsights: () => {
      dispatch((0, _actionCreators.loadMonitoring)());
    },
    showModal: (equipRuleIds, hits, createNewIssue = false) => {
      // Also include equipNames by searching through all hits to find ones that
      // match the supplied ids
      const equipNames = equipRuleIds.map(id => {
        const hit = hits.find(h => h.equipRuleId === id);
        return hit ? hit.targetName : null;
      }).filter(h => h !== null);
      return () => dispatch((0, _reduxModal.show)('TRIAGE_ACTION_MODAL', {
        equipRuleIds,
        equipNames,
        createNewIssue
      }));
    },
    setMultiSite: syncoId => {
      dispatch((0, _selections.updateIsMultiSiteRoute)(false));
      dispatch((0, _selections.selectActiveSite)(syncoId));
    }
  };
};

class EquipScene extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleSort", option => () => {
      this.setState(state => {
        const direction = state.sort.direction === 'asc' ? 'desc' : 'asc';
        (0, _storage.setPersisted)({
          key: PERSIST_KEY,
          prop: PERSIST_PROP
        }, {
          option,
          direction
        });
        return {
          sort: {
            option,
            direction
          }
        };
      });
    });
    (0, _defineProperty2.default)(this, "redirectToMonitoring", () => {
      this.setState({
        redirectingToMonitoring: true
      });
      const {
        search
      } = _browserHistory.history.location;

      _browserHistory.history.push({
        pathname: '/analysis/monitoring',
        search
      });
    });
    const sort = (0, _storage.getPersisted)({
      key: PERSIST_KEY,
      prop: PERSIST_PROP
    }, DEFAULT_SORT);
    this.state = {
      redirectingToMonitoring: false,
      sort
    };
  }

  componentDidMount() {
    const {
      appSetupComplete,
      shouldRequest
    } = this.props;
    const {
      syncoId
    } = this.props.match.params;
    this.props.setMultiSite(syncoId);

    if (appSetupComplete && shouldRequest) {
      this.props.requestInsights();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.appSetupComplete) return;

    const pastQS = _queryStringForAll.default.parse(prevProps.location.search);

    const currentQS = _queryStringForAll.default.parse(this.props.location.search);
    /**
     * If selected sites has changed; then redirect to '/monitoring'
     */


    if (pastQS.sites !== currentQS.sites) {
      this.redirectToMonitoring();
    } else if (!this.state.redirectingToMonitoring && this.props.shouldRequest && !this.props.loading) {
      this.props.requestInsights();
    }
  }

  render() {
    const {
      syncoId,
      ruleId
    } = this.props.match.params;
    const {
      userDisplayName
    } = this.props;
    const {
      error,
      siteGroups,
      showSnoozed,
      appSetupComplete,
      userSites
    } = this.props;
    const {
      sort
    } = this.state;
    if (!appSetupComplete) return /*#__PURE__*/React.createElement(_Loading.default, null);

    if (!this.props.ready) {
      return /*#__PURE__*/React.createElement(_Loading.default, null);
    }

    if (this.props.loading && !this.props.ready) return /*#__PURE__*/React.createElement(_Loading.default, null); // TODO: Error state when requesting data for site that doesn't exist/user can't access
    // 404 redirect?

    if (error) return /*#__PURE__*/React.createElement("h1", null, error);
    const siteGroup = siteGroups[syncoId];

    if (!siteGroup) {
      return /*#__PURE__*/React.createElement("p", null, "There don't seem to be any hits for this site in the selected period");
    }

    const ruleGroup = siteGroup.ruleGroups[ruleId];
    const site = userSites.sites[syncoId];

    if (!ruleGroup || !site) {
      return /*#__PURE__*/React.createElement("p", null, "There don't seem to be any hits for this rule/site combination");
    }

    const {
      ruleName,
      ruleDescription
    } = ruleGroup[0];
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
      title: `Insight - ${ruleName}`
    }), /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_Equip.default, {
      insightType: routes.InsightType.Monitoring,
      hits: ruleGroup,
      ruleName: ruleName,
      ruleDescription: ruleDescription,
      userDisplayName: userDisplayName,
      syncoId: syncoId,
      activeSite: syncoId,
      ruleId: ruleId,
      showSnoozed: showSnoozed,
      sortOption: sort.option,
      sortDirection: sort.direction,
      updateSort: this.handleSort,
      showModal: this.props.showModal,
      urlHistory: this.props.urlHistory,
      selectedSites: this.props.selectedSites
    })));
  }

}

var _default = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EquipScene));

exports.default = _default;
module.exports = exports.default;